import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { NoteMenuActions } from '../types';
import { elementClassListToggle } from '../../../utils/htmlElement.utils';
import { TemplateState } from '../../../types/common/types';
import { formatDate } from '@nirvana/shared/time';
import { htmlEncode } from '../../../utils/escape.utils';
import { Note } from '../../types';

export class NoteCardView extends BaseWebComponentView {
  protected menuActions = [
    {
      title: 'Edit',
      value: NoteMenuActions.EDIT,
    },
    {
      title: 'Delete',
      value: NoteMenuActions.DELETE,
      customClass: 'danger',
    },
  ];

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$sectionContainer = this.shadow.getElementById('sections');
    this.dom.$noteCardMenu = this.shadow.querySelector('#noteCardMenu');
    this.dom.$toolTipNoteCardMenu = this.shadow.querySelector('#tooltipUserFullName');
    this.dom.$userFullname = this.shadow.querySelector('#userFullname');
    this.dom.$createdDate = this.shadow.querySelector('#createdDate');
    this.dom.$description = this.shadow.querySelector('#description');

    this.setTranslatedStrings();
  }

  setTranslatedStrings() {
    for (const menuAction of this.menuActions) {
      switch (menuAction.value) {
        case NoteMenuActions.EDIT:
          menuAction.title = this.dependencies.translateFn('Edit');
          break;

        case NoteMenuActions.DELETE:
          menuAction.title = this.dependencies.translateFn('Delete');
          break;

        default:
          break;
      }
    }
  }

  buildSuccessView(data: Note) {
    this.dom.$userFullname.textContent = this.computeUsername(data);
    this.dom.$toolTipNoteCardMenu.tooltipText = this.computeUsername(data);
    this.dom.$createdDate.textContent = formatDate(data.created);
    let description = htmlEncode(data.text);

    if (data.created !== data.lastUpdated) {
      description += ` <gz-text fontSize="10" class="edited-text">(${this.dependencies.translateFn(
        'edited'
      )} ${formatDate(data.lastUpdated)})</gz-text>`;
    }
    this.dom.$description.innerHTML = description;

    if (this.dependencies.getUser()._id !== data.user._id) {
      elementClassListToggle(this.dom.$noteCardMenu, 'not-visible');
      return;
    }

    this.dom.$noteCardMenu.options = this.menuActions;
  }

  computeUsername(data) {
    if (!data.user) {
      return this.dependencies.translateFn('N/A');
    }
    if (data.user.company && this.dependencies.getUser().company.id !== data.user.company._id) {
      return `${data.user.company.name} (${data.user.name})`;
    }
    return data.user.name;
  }

  buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }
}
